// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"1142b4b8","396":"1142b4b8"}[chunkId] + ".chunk.css";
};